var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F0B429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 22C23.3807 22 24.5 20.8807 24.5 19.5C24.5 18.1193 23.3807 17 22 17C20.6193 17 19.5 18.1193 19.5 19.5C19.5 20.8807 20.6193 22 22 22Z",
    stroke: "#010E20",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0052 30.3332C26.6076 30.3332 30.3385 26.6022 30.3385 21.9998C30.3385 17.3975 26.6076 13.6665 22.0052 13.6665C17.4028 13.6665 13.6719 17.3975 13.6719 21.9998C13.6719 26.6022 17.4028 30.3332 22.0052 30.3332Z",
    stroke: "#010E20",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.972 28.6667C26.8395 26.2571 26.1017 24.5 21.9977 24.5C17.8938 24.5 17.1561 26.2571 17.0234 28.6667",
    stroke: "#010E20",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.870dd05fdbb1ba388fea1abc8bbecc23.svg";
export { ForwardRef as ReactComponent };